import { render, staticRenderFns } from "./gptsAdmin.vue?vue&type=template&id=317ebf1e&"
import script from "./gptsAdmin.vue?vue&type=script&lang=js&"
export * from "./gptsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./gptsAdmin.vue?vue&type=style&index=0&id=317ebf1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports